import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getProvinces () {
        return httpService.get(ApiEndpoints.get('provinces'));
    },
    getProvinceName (id) {
        return this.getProvinces().filter((el) => {
            return el.id.localeCompare(id.toString()) === 0;
        });
    }
};
